module.exports = __webpack_public_path__ + "public/images/math.fbd8a16eeca63587f2423c40306b83f5.jpg";